const cityList = () => {
    const showAllButton = document.querySelector('[data-show-all-facilities-btn]');
    const cityItems = document.querySelectorAll('[data-toggle-list] .city-item.hidden-item');
   
    if (showAllButton) {
        showAllButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const promises = Array.from(cityItems).map(item => {
                // Make sure the image has loaded before animation
                return new Promise(resolve => {
                    const img = item.querySelector('img');
                    if (img && img.complete) {
                        resolve();
                    } else if (img) {
                        img.onload = resolve;
                        img.onerror = resolve;
                    } else {
                        resolve();
                    }
                });
            });

            Promise.all(promises).then(() => {
                cityItems.forEach((item, index) => {
                    setTimeout(() => {
                        item.classList.remove('hidden-item');
                        item.setAttribute('aria-hidden', 'false')
                        item.classList.add('visible-item');
                    }, index * 100); // Stagger the animation for each item
                });

              
                // Remove button
                 showAllButton.style.display = 'none';
               
            });
        });
    }
};

document.addEventListener('DOMContentLoaded', () => {
    cityList();
});
